import * as React from 'react';
import dayjs from 'dayjs';

import {Trans} from '@deviceinsight/ng-ui-scale-lib/api';
import {DateFormats} from '../kpiUtils';
import './LastUpdateInfo.scss';

type Props = {
	time: number | null | undefined;
};

const LastUpdateInfo = ({time}: Props) => {
	const timeInfo = dayjs(time).format(DateFormats.DATE_TIME_DISPLAY);
	return (
		<div className="di last-update-info">
			<Trans i18nKey="dashboard.widgets.kpi.lastUpdate">Last update:</Trans>
			{time ? ` ${timeInfo}` : ' --'}
		</div>
	);
};

export default LastUpdateInfo;
